<template>
  <div
    class="tw-py-[59px] tw-pl-[14%] md:tw-py-[57px] md:tw-pl-0 md:tw-text-center"
  >
    <div class="md:tw-inline-block tw-mb-2 md:tw-mb-0 md:tw-mx-4">
      <SfRouterLink :to="mathsHomeUrl">
        <img
          src="/sitemedia/mf-logo2.png"
          alt="Mathsframe Ltd. Logo"
          class="mf-logo-filter tw-w-[344px]"
        />
      </SfRouterLink>
    </div>
    <div class="md:tw-inline-block md:tw-mx-4">
      <SfRouterLink to="/">
        <img
          src="/sitemedia/sf-logo2.png"
          alt="Spellingframe Ltd. Logo"
          class="sf-logo-filter tw-w-[344px]"
        />
      </SfRouterLink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SfRouterLink from "./shared/SfRouterLink.vue";
import userHasRole from "@/func/user/userHasRole";

export default defineComponent({
  components: { SfRouterLink },
  computed: {
    mathsHomeUrl() {
      if(this.$currentUser.value?.hasMathsAccess) {
        if(userHasRole(this.$currentUser.value, ['individual', 'student'])) {
          return '/dashboard/maths';
        }
        return '/maths';
      }
      return '/';
    }
  }
});
</script>
